import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { t } = useLanguage();
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect after successful login based on role
  useEffect(() => {
    if (user) {
      navigate(user.role === 'admin' ? '/admin' : '/portal');
    }
  }, [user, navigate]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      // After login, check user role from context (need small delay for state update)
    } catch (err: any) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 72, background: 'var(--bg-section)' }}>
      <div style={{ width: '100%', maxWidth: 440, padding: '0 24px' }}>
        <div style={{ background: 'white', border: '1px solid var(--border)', padding: '48px 40px' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>{t('auth.login')}</h1>
          <p style={{ fontSize: 15, color: 'var(--text-secondary)', marginBottom: 32 }}>Maluz Technologies</p>

          {error && (
            <div data-testid="login-error" style={{ padding: '12px 16px', background: 'rgba(211,47,47,0.08)', border: '1px solid var(--secondary)', color: 'var(--secondary)', marginBottom: 20, fontSize: 14 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 24 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{t('auth.email')}</label>
                <input
                  data-testid="login-email-input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={{ width: '100%', padding: '12px 14px', border: '1px solid var(--border)', fontSize: 15, outline: 'none', boxSizing: 'border-box' }}
                  onFocus={e => (e.currentTarget.style.borderColor = 'var(--primary)')}
                  onBlur={e => (e.currentTarget.style.borderColor = 'var(--border)')}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{t('auth.password')}</label>
                <input
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  style={{ width: '100%', padding: '12px 14px', border: '1px solid var(--border)', fontSize: 15, outline: 'none', boxSizing: 'border-box' }}
                  onFocus={e => (e.currentTarget.style.borderColor = 'var(--primary)')}
                  onBlur={e => (e.currentTarget.style.borderColor = 'var(--border)')}
                />
              </div>
            </div>
            <button
              type="submit"
              data-testid="login-submit-btn"
              disabled={loading}
              style={{ width: '100%', padding: '14px', background: 'var(--primary)', color: 'white', fontWeight: 600, fontSize: 15, border: 'none', textTransform: 'uppercase', letterSpacing: '0.05em', transition: 'background 0.2s', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? '...' : t('auth.login')}
            </button>
          </form>

          <div style={{ marginTop: 16, textAlign: 'right' }}>
            <Link to="/forgot-password" data-testid="forgot-password-link" style={{ fontSize: 13, color: 'var(--text-muted)' }}>{t('auth.forgot_password')}</Link>
          </div>

          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)' }}>
              {t('auth.no_account')} <Link to="/register" data-testid="register-link" style={{ color: 'var(--primary)', fontWeight: 600 }}>{t('auth.register')}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
